var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OneCol',[_c('Heading',{attrs:{"title":_vm.$t('onboarding.heading').toString(),"text":_vm.$t('onboarding.text').toString()}}),_c('OnboardingWizard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }